/** Personal device appearance. Never changes organization branding or routes. */
export const APPEARANCE_KEY = 'bp.appearance';
export const DEFAULT_APPEARANCE = 'dark';
export const isAppearance = value => value === 'light' || value === 'dark';
const listeners = new Set();
let current = DEFAULT_APPEARANCE;
let initialized = false;

export function getAppearance() { return current; }
export function subscribeAppearance(listener) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
function apply(value) {
  current = isAppearance(value) ? value : DEFAULT_APPEARANCE;
  const root = document.documentElement;
  root.dataset.appearance = current;
  root.style.colorScheme = current;
  root.style.backgroundColor = current === 'light' ? '#F3F4F6' : '#17191F';
  document.querySelector('meta[name="color-scheme"]')?.setAttribute('content', current);
  // Vanilla authentication controls update in place; inputs and focus survive.
  document.querySelectorAll('[data-appearance-option]').forEach(button => {
    button.setAttribute('aria-pressed', String(button.dataset.appearanceOption === current));
  });
  listeners.forEach(listener => listener());
}
export function setAppearance(value) {
  if (!isAppearance(value)) return false;
  apply(value);
  try { localStorage.setItem(APPEARANCE_KEY, value); } catch { /* Storage may be unavailable; keep this session usable. */ }
  return true;
}
export function initAppearance() {
  if (initialized) return;
  initialized = true;
  let saved = document.documentElement.dataset.appearance;
  try { saved = localStorage.getItem(APPEARANCE_KEY); } catch { /* Use the pre-paint choice. */ }
  apply(saved);
  window.addEventListener('storage', event => {
    if (event.key === APPEARANCE_KEY || event.key === null) apply(event.newValue);
  });
}
